export default function authHeader() {
    let user_access_token = JSON.parse(localStorage.getItem('access_token'));
  
    if (user_access_token) {
      return { Authorization: 'Bearer ' + user_access_token }; 
    } else {
      return {};
    }
  }
  